// NOTE: this component should NOT be used for new UIs

import React, {Component} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {RouterLink} from "../Link"
import Card from "./Card"
import Icon, {IconTypes} from "../Icon"

const StyledLinkWrapper = styled.div`
  left: -15px;
  position: absolute;
`

class ShadowCard extends Component {
  static propTypes = {
    bothSides: PropTypes.bool,
    children: PropTypes.node,
    linkProps: PropTypes.shape({
      app: PropTypes.object,
      onClick: PropTypes.func,
      to: PropTypes.string
    })
  }

  static defaultProps = {
    children: null,
    linkProps: null
  }

  render() {
    const {children, linkProps} = this.props

    return (
      <Card>
        {linkProps && (
          <StyledLinkWrapper>
            <RouterLink {...linkProps} plain>
              <Icon icon={IconTypes.chevronLeft} extraLarge marginTop={2} />
            </RouterLink>
          </StyledLinkWrapper>
        )}
        {children}
      </Card>
    )
  }
}

export default ShadowCard
